var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { createRef } from "react";
import { getConfigVar } from "../../utils/Configuration";
import { EmptyComponent } from "../../utils/EmptyComponent";
import { concatClassNames, filterChildrenOfType, getCalendar, range } from "../../utils/Functions";
import { Datepicker } from "../form/Datepicker";
import { Button } from "./Button";
import { Tooltip } from "./Tooltip";
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.datePicker = createRef();
        _this.componentDidUpdate = function (prevProps) {
            var _a, _b;
            if (((_a = prevProps.current) === null || _a === void 0 ? void 0 : _a.getTime()) !== ((_b = _this.props.current) === null || _b === void 0 ? void 0 : _b.getTime()) && _this.props.current) {
                _this.setYear(_this.props.current.getFullYear());
                _this.setMonth(_this.props.current.getMonth());
            }
        };
        _this.setYear = function (year) { return _this.setState({ year: year }); };
        _this.setMonth = function (month) { return _this.setState({ month: month }); };
        _this.prevMonth = function () {
            var _a = _this.state, month = _a.month, year = _a.year, date = new Date(year, month);
            date.setMonth(date.getMonth() - 1);
            _this.setYear(date.getFullYear());
            _this.setMonth(date.getMonth());
        };
        _this.nextMonth = function () {
            var _a = _this.state, month = _a.month, year = _a.year, date = new Date(year, month);
            date.setMonth(date.getMonth() + 1);
            _this.setYear(date.getFullYear());
            _this.setMonth(date.getMonth());
        };
        _this.changeParams = function () { return setTimeout(function () { return _this.datePicker.current.setShowing("days"); }); };
        _this.render = function () {
            var _a = _this.state, year = _a.year, month = _a.month, _b = _this.props, className = _b.className, style = _b.style, cells = filterChildrenOfType(_this, CalendarDay).filter(function (c) { return c.props.date.getMonth() === month && c.props.date.getFullYear() === year; }), calendar = getCalendar(year, month);
            return React.createElement("table", { className: concatClassNames("dolfo-calendar", className), style: style },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { colSpan: 7 },
                            React.createElement("div", null,
                                React.createElement(Tooltip, { label: getConfigVar("SELECT") },
                                    React.createElement(Button, { color: "white", shape: "pill", onClick: _this.changeParams, style: { fontWeight: 500 } },
                                        getConfigVar("MONTH_" + (month + 1)).toUpperCase(),
                                        " ",
                                        year)),
                                React.createElement(Datepicker, { showToday: true, ref: _this.datePicker, onChange: function (d) {
                                        if (d) {
                                            _this.setMonth(d.getMonth());
                                            _this.setYear(d.getFullYear());
                                        }
                                        else {
                                            _this.setMonth(new Date().getMonth());
                                            _this.setYear(new Date().getFullYear());
                                        }
                                    } }),
                                React.createElement("div", { className: "calendar-btns" },
                                    React.createElement(Tooltip, { label: getConfigVar("PREVIOUS") },
                                        React.createElement(Button, { color: "white", shape: "pill", onClick: _this.prevMonth },
                                            React.createElement(FontAwesomeIcon, { icon: faChevronLeft, size: "lg" }))),
                                    React.createElement(Tooltip, { label: getConfigVar("NEXT") },
                                        React.createElement(Button, { color: "white", shape: "pill", onClick: _this.nextMonth },
                                            React.createElement(FontAwesomeIcon, { icon: faChevronRight, size: "lg" }))))))),
                    React.createElement("tr", null, range(1, 8).map(function (d) { return React.createElement("th", { key: d }, getConfigVar("WEEK_DAY_" + d)); }))),
                React.createElement("tbody", null, calendar.map(function (row, i) { return React.createElement("tr", { key: i }, row.map(function (day, ii) {
                    var cellEvents = cells.filter(function (c) { return c.props.date.getDate() === day; });
                    return React.createElement("td", { key: i + "-" + ii, className: day.toString().indexOf("_") >= 0 ? "other-month" : "" },
                        React.createElement("div", null,
                            day.toString().replace("_", ""),
                            React.createElement("div", { className: "dolfo-calendar-day" }, cellEvents.map(function (c) { return c.props.children; }))));
                })); })));
        };
        var date = props.current || new Date();
        _this.state = {
            year: date.getFullYear(),
            month: date.getMonth()
        };
        return _this;
    }
    return Calendar;
}(React.Component));
export { Calendar };
/** Defines the single day of the calendar with its content */
var CalendarDay = /** @class */ (function (_super) {
    __extends(CalendarDay, _super);
    function CalendarDay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CalendarDay;
}(EmptyComponent));
export { CalendarDay };
